import { AxiosInstance } from 'axios';
import * as moment from 'moment';

import {
  IOptions,
  ILink,
  ITargetCheckDashboard,
} from 'src/views/TargetCheck/types';
import { cancellable } from '../cancellable';

const DATE_FORMAT = `YYYY-MM-DDTHH:mm:ss`;
const LINKS_PER_PAGE = 10;

const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }
  const { entries, count } = response.result;
  return {
    pageCount: Math.ceil(count / LINKS_PER_PAGE),
    links: entries.map((link: ILink) => {
      const { createdOn, dateFrom, dateTo, ...rest } = link;

      return {
        ...rest,
        createdOn: createdOn
          ? createdOn.replace('T', ' ').replace('Z', '')
          : '',
        dateFrom: dateFrom ? moment(dateFrom).toDate() : new Date(),
        dateTo: dateTo ? moment(dateTo).toDate() : new Date(),
      };
    }),
  };
};

const toQueryParams = (filters: IOptions) => {
  return Object.entries(filters)
    .filter(([_, value]) => Boolean(value))
    .map(([name, value]) => {
      if (name.indexOf('date') !== -1) {
        return `${name}=${moment(value).format(DATE_FORMAT)}`;
      }
      if (name === 'searchTerm') {
        return `searchWord=${value}`;
      }
      if (name === 'page') {
        return `pageSkip=${value - 1}`;
      }
      return `${name}=${value}`;
    })
    .join('&');
};

export default (api: AxiosInstance, url: string) => (filters: IOptions) => {
  const urlWithParams = `${url}?pageSize=${LINKS_PER_PAGE}&${toQueryParams(
    filters
  )}`;
  return cancellable<ITargetCheckDashboard>(
    (cancelOptions: any) => api.get(urlWithParams, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/targetCheck/getDashboard.ts